import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DingtalkPermissionService {

  //钉钉相关
  saas:string = environment.saasWebAPI

  agentId:string = environment.dingTalkAgentId

  constructor(
    
    private http: SwHttpClientService,
  ) { }
  

  /**
   * 查询钉钉应用列表
   */
  getDingTalkAppList(param) {
    const url = this.saas + 'dingtalk/getAppList?agentId=' + this.agentId;
    return this.http.Post(url, param)
  }

  /**
   * 查询应用可见人员id列表
   * @param id 应用id
   */
  getAppVisableScope(id) {
    const url = this.saas + 'dingtalk/getAppVisableScope?agentId=' + id;
    return this.http.Post(url, {})
  }

  setAppVisableScopes(id, userIds) {
    const url = this.saas + 'dingtalk/setAppVisableScopes?agentId=' + id;
    return this.http.Post(url, userIds)
  }
}
